export default {
    // baseURL: "localhost:8000/apitest/public/",

    //Koneksi Lokal
    // baseURL: "http://192.168.26.4/apinew/public/",

    baseURL: "https://apiastor.asia.ac.id/public/",
}